import type React from 'react';
import { flowRight } from 'lodash';
import ProvisioningPage from '../containers/provisioning-page';
import { withDirection, type WithDirection } from './with-direction';
import { withInvalidState, type WithInvalidState } from './with-invalid-state';
import { withLayoutUpdate, type WithLayoutUpdate } from './with-layout-update';
import { withProvisioning, type WithProvisioning } from './with-provisioning';

export type WithViewer = WithDirection & WithProvisioning & WithInvalidState & WithLayoutUpdate;

export function withViewer<P extends WithViewer>(AppRoot: React.ComponentType<P>) {
  return flowRight(
    withDirection,
    withProvisioning(ProvisioningPage),
    withInvalidState,
    withLayoutUpdate,
  )(AppRoot);
}
